module.exports = __webpack_public_path__ + "static/media/illustration-archive-room.f0e71847.svg";